import * as React from 'react';
import { Avatar } from './Avatar';

export const TextAvatarSizes = ["16px", "20px", "24px", "32px", "42px", "40px", "48px", "56px", "64px"] as const;
export type TextAvatarSize = typeof TextAvatarSizes[number];

export type TextAvatarProps = {
    text: string,
    size?: TextAvatarSize,
    identifier?:string,
    backgroundColor?:string,
    contentColor?:string,
    borderColor?:string,
    colorGenerationString?:string,
    selected?:boolean,
    toolTip?:React.ReactNode,
    onClick?: (identifier:string) => void
};

export function TextAvatar (props: TextAvatarProps): JSX.Element
{
    const fontSizes = [
        { size: '16px', fontSize: '8px', fontWeight: 400 },
        { size: '20px', fontSize: '10px', fontWeight: 400 },
        { size: '24px', fontSize: '12px', fontWeight: 400 },
        { size: '32px', fontSize: '14px', fontWeight: 400 },
        { size: '40px', fontSize: '20px', fontWeight: 400 },
        { size: '42px', fontSize: '20px', fontWeight: 400 },
        { size: '48px', fontSize: '24px', fontWeight: 400 },
        { size: '56px', fontSize: '28px', fontWeight: 400 },
        { size: '64px', fontSize: '32px', fontWeight: 400 },
    ];

    let sizePair = fontSizes.find(fs => fs.size === props.size);
    if (!sizePair)
        sizePair = fontSizes[2];


    return (
        <Avatar size={sizePair.size}
            {...props}>

            <span style={{ fontSize: sizePair.fontSize, fontWeight: sizePair.fontWeight }}>
                {props.text}
            </span>

        </Avatar>
    );
}
